import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';


export default class TableHeader extends PureComponent {
    static propTypes = {
        headers: PropTypes.array.isRequired,
        width: PropTypes.number
    }

    static defaultProps = {
        width: null
    }

    constructor(props) {
        super(props);
    }

    render() {
        const headers = this.props.headers.map(item =>
            <span className={`cell cell-${item.key}`} key={item.key}>{item.content ? item.content : item.label}</span>)
        return <div className="light-table__headers"
             style={ this.props.width ? {width: this.props.width + 'px'} : null}>
            {headers}
        </div>
    }

}


// WEBPACK FOOTER //
// ./src/scripts/reusable/LightTable/Components/TableHeader.jsx